import { lazy } from 'react';

const MyTicketView = lazy(() => import('./MyTicketView'));

export default MyTicketView;
